// frontend/src/notifications/domainIcon.js
import { V2 } from '../theme/tokens'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import StorefrontIcon from '@mui/icons-material/Storefront'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import TravelExploreIcon from '@mui/icons-material/TravelExplore'
import NotificationsIcon from '@mui/icons-material/Notifications'

const ICON_BY_DOMAIN = {
  rma: SupportAgentIcon,
  po: LocalShippingIcon,
  pricing: StorefrontIcon,
  sync: SyncProblemIcon,
  ops: AdminPanelSettingsIcon,
  scraper: TravelExploreIcon,
}

const COLOR_BY_URGENCY = {
  low: V2.ink45,
  normal: V2.primaryText,
  high: V2.warnText,
  sla_breach: V2.errText,
}

export function getDomainIcon(domain) {
  return ICON_BY_DOMAIN[domain] || NotificationsIcon
}

export function getUrgencyColor(urgency) {
  return COLOR_BY_URGENCY[urgency] || COLOR_BY_URGENCY.normal
}
